<template>
<div>
    <div class="xin1" v-loading="loading">
        <div class="swicth">
            <!-- 查询框 -->
            <div class="main1">
                <el-button type="primary" @click="back">{{$t("list.return")}}</el-button>
                <el-button @click="xiazai">{{$t("list.download")}}</el-button>
                <el-button @click="dawdata">{{$t("list.rawdata")}}</el-button>
                <el-button @click="header">{{$t("list.header")}}</el-button>
                <el-button @click="cancel_send" v-if="this.need_send==1">{{$t("list.cancel_send")}}</el-button>
                <!--   <el-button @click="reason">{{$t("list.whyspam")}}</el-button>
                <el-button @click="abstract">{{$t("list.show")}}</el-button>
                <el-button @click="matter">{{$t("list.body")}}</el-button>
                <el-button @click="original">{{$t("list.origin")}}</el-button>
                <el-button @click="print">{{$t("list.info")}}</el-button>
                <el-button>{{$t("list.trainspam")}}</el-button>
                <el-button>{{$t("list.trainnormal")}}</el-button>-->
                <!--  <el-button icon="el-icon-search" @click="back">{{
            $t("list.return")
          }}</el-button>
                <el-button icon="el-icon-download" @click="xiazai">{{
            $t("list.download")
          }}</el-button>
                <el-button icon="el-icon-check" @click="pass">{{
            $t("list.pass")
          }}</el-button>
                <el-button icon="el-icon-receiving" @click="dawdata">{{
            $t("list.rawdata")
          }}</el-button>
                <el-button icon="el-icon-message" @click="header">{{
            $t("list.header")
          }}</el-button>
                <el-button icon="el-icon-help" @click="reason">{{
            $t("list.whyspam")
          }}</el-button>
                <el-button icon="el-icon-s-fold" @click="abstract">{{
            $t("list.show")
          }}</el-button>
                <el-button icon="el-icon-edit-outline" @click="matter">{{
            $t("list.body")
          }}</el-button>
                <el-button icon="el-icon-c-scale-to-original" @click="original">{{
            $t("list.origin")
          }}</el-button>
                <el-button icon="el-icon-document-copy" @click="print">{{
            $t("list.info")
          }}</el-button>
                <el-button icon="el-icon-notebook-2">{{
            $t("list.trainspam")
          }}</el-button>
                <el-button icon="el-icon-full-screen">{{
            $t("list.trainnormal")
          }}</el-button>-->
            </div>
            <!-- 内容区域 -->
            <div class="cent">
                <!-- 分词信息 -->

                <ol class="reason" v-show="print2">
                    <li>
                        {{ $t("list.info") }}:<el-button @click="yin4">{{
                $t("list.hide")
              }}</el-button>
                    </li>

                    <el-input type="textarea" :rows="10" v-model="print1"> </el-input>
                </ol>
                <!-- 原始正文 -->

                <ol class="reason" v-show="original2">
                    <li>
                        {{ $t("list.origin") }}:<el-button @click="yin3">{{
                $t("list.hide")
              }}</el-button>
                    </li>

                    <el-input type="textarea" :rows="10" v-model="original1">
                    </el-input>
                </ol>
                <!-- 正文分析 -->

                <ol class="reason" v-show="matter2">
                    <li>
                        {{ $t("list.body") }}:<el-button @click="yin2">{{
                $t("list.hide")
              }}</el-button>
                    </li>
                    <li v-html="matter1"></li>
                </ol>
                <!-- 显示摘要 -->

                <ol class="reason" v-show="abstract2">
                    <li>
                        {{ $t("list.show") }}:<el-button @click="yin1">{{
                $t("list.hide")
              }}</el-button>
                    </li>
                    <li v-html="abstract1"></li>
                </ol>
                <!-- 原因分析 -->
                <ol class="reason" v-show="reason2">
                    <li>
                        {{ $t("list.whyspam") }}:<el-button @click="yin">{{
                $t("list.hide")
              }}</el-button>
                    </li>

                    <li style="white-space: pre-wrap;">{{ reason1 }}</li>
                </ol>

                <p v-html="fileList.SUBJECT"></p>

                <ul>
                    <li>{{ $t("list.from") }}:</li>
                    <li>{{ fileList.FROMNAME }} <span class="list_text">{{ fileList.FROMADDR }}</span> </li>
                </ul>
                <ul>
                    <li>{{ $t("list.to") }}:</li>
                    <li v-html="fileList.TO" class="list_text">{{}}</li>
                </ul>
                <ul>
                    <li>{{ $t("list.data") }}:</li>
                    <li class="list_text">{{ fileList.DATE }}</li>
                </ul>
                <ul v-if="fileList.ATTACHMENT == 1">
                    <li>{{ $t("list.attach") }}:</li>
                    <li class="yichu">
                        ({{ fnameage }} {{ $t("list.num") }} ){{ fname }}
                    </li>
                </ul>
                <!--  信封发件人 -->
                <ul>
                    <li>{{ $t("list.envfrom") }}:</li>
                    <li>

                        {{ fileList.ENVFROM }}
                        <span v-if="fileList.DELETE_BLACK_EMAIL_IN_SPAM == 1">{{
                $t("tan.bte")
              }}</span>
                        <span v-if="fileList.DELETE_WHITE_EMAIL_IN_SPAM == 1">{{
                $t("tan.wte")
              }}</span>
                    </li>
                    <li v-if="fileList.ADD_BLACK_EMAIL_IN_SPAM == 1">
                        <el-button @click="tan1">{{ $t("list.bte") }}</el-button>
                        <el-button @click="tan2">{{ $t("list.wte") }}</el-button>
                    </li>
                      <li v-if="fileList.BLACK_EMAIL_IS_IN_SPAM == 1">
                       {{$t('tan.bte')}} <el-button @click="tan11">{{$t('list.bte1')}}</el-button>
                    </li>
                    <li v-if="fileList.DELETE_WHITE_EMAIL_IN_SPAM == 1">
                        {{$t('tan.wte')}} <el-button @click="tan12">{{$t('list.wte1')}}</el-button>
                    </li>
                  
                </ul>
                <ul>
                    <li>{{ $t("list.envrcpt") }}:</li>
                    <li>{{ fileList.ENVRCPT }}</li>
                </ul>
                <ul>
                    <li>{{ $t("list.id") }}:</li>
                    <li>{{ fileList.QUEUE_ID }}</li>
                </ul>
                <ul>
                    <li>{{ $t("list.ip") }}:</li>
                    <li>
                        {{ fileList.PEER_IP }}
                        <span v-if="fileList.DELETE_BLACK_IP_IN_SPAM == 1">{{
                $t("tan.wti1")
              }}</span>
                        <span v-if="fileList.DELETE_WHITE_IP_IN_SPAM == 1">{{
                $t("tan.bti1")
              }}</span>
                    </li>
                    <li v-if="fileList.ADD_BLACK_IP_IN_SPAM == 1">
                        <el-button @click="tan3">{{ $t("list.bti") }}</el-button>
                        <el-button @click="tan4">{{ $t("list.bti") }}</el-button>
                    </li>
                    <li v-if="fileList.DELETE_BLACK_IP_IN_SPAM == 1">
                         {{$t('tan.bti1')}}<el-button @click="tan13">{{$t('list.bti1')}}</el-button>
                    </li>
                    <li v-if="fileList.DELETE_WHITE_IP_IN_SPAM == 1">
                        {{$t('tan.wti1')}} <el-button @click="tan14">{{$t('list.wti1')}}</el-button>
                    </li>
                </ul>
                <ul>
                    <li>replyto:</li>
                    <li>{{ fileList.REPLY_TO_NAME }}{{ fileList.FROMADDR }}</li>
                </ul>
            </div>

            <!-- 展示 -->
            <div class="cent2" v-html="html"></div>
            <!-- 附件 -->
            <div class="footer" v-if="fileList.ATTACHMENT == 1">
                <p>
                    <img src="/imgs/fujian.png" alt />
                    {{ $t("list.fu") }}({{ fnameage }} {{ $t("list.num") }})
                </p>
                <div v-for="v in fujian" :key="v.id">
                    <img :src="`/imgs/${v.FILETYPE}.png`" alt />

                    <ul>
                        <li>{{ v.NAME }}({{ v.HSIZE }})</li>
                        <li @click="down(v.CNT)">{{ $t("list.download") }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            fileList: [],
            fujian: [],
            fujian1: [],
            html: "",
            html1: "",
            loading: true,
            // 原因分析
            reason1: "",
            reason2: false,
            // 显示摘要
            abstract1: "",
            abstract2: false,
            // 正文分析
            matter1: "",
            matter2: false,

            // 原始正文
            original1: "",
            original2: false,

            // 分词信息
            print1: "",
            print2: false,
            // 附件名
            fname: "",
            // 附件个数
            fnameage: 0,
            // 判断加入还是移出黑名单
            pan1: true,
            need_send: '',
        };
    },
    mounted() {
        this.getFileList();
    },

    methods: {
        //取消发送
        cancel_send() {
            this.$confirm(`${this.$t('anti_gs1_tan.cancel_send1')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let rec_id = this.$route.params.rec_id;
                    this.$axios
                        .get("/api/adm/cgi/readmsg.cgi", {
                            params: {
                                __mode: "act_defer",
                                sid: sid,
                                send: 2,
                                rec_id: rec_id
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                // this.getFileList2();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.cancel_send2')}`,
                                });
                                this.$router.push({
                                    name: "deferSend_list",
                                });
                            }
                        });
                })

                .catch(() => {
                    // this.$message({
                    //     type: "info",
                    //     message: "已取消删除",
                    // });
                });
        },
        // 下载
        down(a) {
            // console.log(this.$route.params);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download";
            // console.log(__mode);

            let rec_id = this.$route.params.rec_id;
            // console.log(rec_id);

            let index = this.$route.params.index;
            // console.log(index);

            let msgtype = this.$route.params.msgtype;
            // console.log(msgtype);
            let cnt = cnt;

            // console.log(a);

            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&index=${index}&msgid=&msgtype=${msgtype}&mimeid=${a}`
            );
        },

        // 放行
        pass() {
            this.$confirm("将放行此邮件，你确定不是垃圾邮件吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "放行成功!",
                    });
                    this.pass1();
                    this.$router.push({
                        name: "wasteInsulate1",
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 放行条件
        pass1() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件
            let rec_id = this.$route.params.rec_id;
            let index = this.$route.params.index;
            let msgtype = this.$route.params.msgtype;
            let col1 = this.$route.params.col1;
            this.$axios
                .get("/api/adm/cgi/elkspam.cgi", {
                    params: {
                        __mode: "pass_elkspam",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,
                        is_elk: 1,
                        msgtype: msgtype,
                        col: col1,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        console.log(res);
                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    // alert(err);
                });
        },
        // 信头
        header() {
            // console.log(this.$route.params);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "readmsg_header";
            // console.log(__mode);

            let rec_id = this.$route.params.rec_id;
            // console.log(rec_id);

            let index = this.$route.params.index;
            // console.log(index);

            let msgtype = this.$route.params.msgtype;
            // console.log(msgtype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&index=${index}&msgid=&msgtype=${msgtype}`
            );
        },
        // 原始邮件
        dawdata() {
            // console.log(this.$route.params);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let __mode = "readmsg_rawdt";
            // console.log(__mode);

            let rec_id = this.$route.params.rec_id;
            // console.log(rec_id);

            // let index = this.$route.params.index;
            // console.log(index);

            let msgtype = this.$route.params.msgtype;
            console.log(msgtype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&msgid=&msgtype=${msgtype}`
            );
        },
        // 分词信息
        print() {
            this.print2 = true;
        },
        // 原始正文
        original() {
            this.original2 = true;
        },
        // 正文分析
        matter() {
            this.matter2 = true;
        },
        // 显示摘要
        abstract() {
            this.abstract2 = true;
        },
        // 原因分析abstract
        reason() {
            this.reason2 = true;
        },
        yin4() {
            this.print2 = false;
            // this.abstract2 = false;
        },
        yin3() {
            this.original2 = false;
            // this.abstract2 = false;
        },
        yin2() {
            this.matter2 = false;
            // this.abstract2 = false;
        },
        yin() {
            this.reason2 = false;
            // this.abstract2 = false;
        },
        yin1() {
            // this.reason2 = false;
            this.abstract2 = false;
        },
        // 下载
        xiazai() {
            // console.log(this.$route.params);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_eml";
            // console.log(__mode);

            let rec_id = this.$route.params.rec_id;
            // console.log(rec_id);

            let index = this.$route.params.index;
            // console.log(index);

            let msgtype = this.$route.params.msgtype;
            // console.log(msgtype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(
                `/api/adm/cgi/readmsg.cgi?__mode=${__mode}&sid=${sid}&rec_id=${rec_id}&index=${index}&msgid=&msgtype=${msgtype}`
            );
        },

        // },
        // 返回
        back() {
            console.log(this.$route.params);

            let col = this.$route.params.col1;
            // console.log(col, '小和尚从来col')
            // this.$router.back();
            this.$router.push({
                name: "deferSend_list",
                params: {
                    // page: this.$route.params.col1.page,
                    // pagesize: this.$route.params.col1.pagesize,

                    // totalnums: this.$route.params.col1.totalnums,
                    col: col,
                },
            });
            // this.$router.push({name:'wasteInsulate1',params:{
            //     col1:col1
            // }})
            // history.back(-1)
            // this.$router.go(-1);
            // console.log(this.$route);
            //
        },
        // 数据

        getFileList() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this.$route.params);
            // 获取表单数据,搜索条件
            let rec_id = this.$route.params.rec_id;
            let index = this.$route.params.index;
            let msgtype = this.$route.params.msgtype;
            let col1 = this.$route.params.col1;
            // let  recid=this.$route.params
            // console.log(rec_id);
            console.log(msgtype);
            //  
            // console.log(this.$route.params);
            this.$axios
                .get("/api/adm/cgi/readmsg.cgi", {
                    params: {
                        __mode: "readmsg_sum",
                        index: index,
                        sid: sid,
                        rec_id: rec_id,

                        msgtype: msgtype,
                        CONDITION_COL: col1,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(res.data.fmstatus.code);
                    if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.back();
                    } else if (res.data.fmstatus.code == "2") {
                        //  alert(55555)
                        alert(res.data.fmstatus.errmsg);
                        this.$router.back();
                    } else {
                        this.fileList = res.data.ret;
                        this.fujian = res.data.ret.datalist;
                        if (res.data.ret.datalist) {
                            let a = 0;
                            for (let i = 0; i <= this.fujian.length; i++) {
                                a = i;
                            }
                            this.fnameage = a;
                            this.fname = res.data.ret.datalist[0].NAME;
                        }
                        this.need_send = res.data.ret.NEED_SEND
                        // console.log(this.fujian.length)
                        // console.log(a)

                        // console.log(this.fname);
                        this.html = res.data.ret.BODY;
                        this.html1 = res.data.ret.SUBJECT;
                        this.loading = false;

                        // 分词信息
                        this.$axios
                            .get("/api/adm/cgi/readmsg.cgi", {
                                params: {
                                    __mode: "printparticipleinfo",
                                    index: index,
                                    sid: sid,
                                    rec_id: rec_id,
                                    is_elk: 1,
                                    msgtype: msgtype,
                                    // screen: "real_filterlog.html",
                                },
                            })
                            .then((res) => {
                                // console.log(res,'111111111111')
                                this.print1 = res.data.ret.PAETICIPLE_INFO;
                            })
                            .catch((err) => {
                                // console.log("接口错误");
                                console.log(err);
                                // alert(err);
                            });
                        // 原始正文
                        // this.$axios
                        //     .get("/api/adm/cgi/readmsg.cgi", {
                        //         params: {
                        //             __mode: "printoriginalbody",
                        //             index: index,
                        //             sid: sid,
                        //             rec_id: rec_id,
                        //             is_elk: 1,
                        //             msgtype: msgtype,
                        //             // screen: "real_filterlog.html",
                        //         },
                        //     })
                        //     .then((res) => {
                        //         // console.log(res);
                        //         this.original1 = res.data.ret.ORIG_BODY;
                        //     })
                        //     .catch((err) => {
                        //         // console.log("接口错误");
                        //         console.log(err);
                        //         // alert(err);
                        //     });
                        // // 原因分析
                        // this.$axios
                        //     .get("/api/adm/cgi/readmsg.cgi", {
                        //         params: {
                        //             __mode: "view_reason",
                        //             index: index,
                        //             sid: sid,
                        //             rec_id: rec_id,
                        //             is_elk: 1,
                        //             msgtype: msgtype,
                        //             // screen: "real_filterlog.html",
                        //         },
                        //     })
                        //     .then((res) => {
                        //         // console.log(res)
                        //         this.reason1 = res.data.ret.REASON;
                        //     })
                        //     .catch((err) => {
                        //         // console.log("接口错误");
                        //         console.log(err);
                        //         // alert(err);
                        //     });
                        // this.$axios
                        //     .get("/api/adm/cgi/readmsg.cgi", {
                        //         params: {
                        //             __mode: "showdigest",
                        //             index: index,
                        //             sid: sid,
                        //             rec_id: rec_id,
                        //             is_elk: 1,
                        //             msgtype: msgtype,
                        //             // screen: "real_filterlog.html",
                        //         },
                        //     })
                        //     .then((res) => {
                        //         // console.log(res)

                        //         this.abstract1 = res.data.ret.DIGEST;

                        //         // console.log( this.html)
                        //     })
                        //     .catch((err) => {
                        //         // console.log("接口错误");
                        //         console.log(err);
                        //         // alert(err);
                        //     });
                        this.$axios
                            .get("/api/adm/cgi/readmsg.cgi", {
                                params: {
                                    __mode: "printnumemail",
                                    index: index,
                                    sid: sid,
                                    rec_id: rec_id,
                                    is_elk: 1,
                                    msgtype: msgtype,
                                    // screen: "real_filterlog.html",
                                },
                            })
                            .then((res) => {
                                // console.log(res);

                                this.matter1 = res.data.ret.DETAIL;
                            })
                            .catch((err) => {
                                // console.log("接口错误");
                                console.log(err);
                                // alert(err);
                            });
                    }
                })
                .catch((err) => {
                    // console.log("接口错误");
                    console.log(err);
                    alert(err);
                });
        },
        // email移出黑名单
        tan11() {
            this.$confirm(`${this.$t("tan.tan11")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_blsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },
        //  email移出白名单
        tan12() {
            this.$confirm(`${this.$t("tan.tan12")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_wlsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },
        //  ip移出黑名单
        tan13() {
            this.$confirm(`${this.$t("tan.tan13")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_ipbl",
                                blip: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        }, //  ip移出白名单
        tan14() {
            this.$confirm(`${this.$t("tan.tan14")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_ipwl",
                                wlip: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm2")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel2")}`,
                    });
                });
        },
        // 弹框
        tan1() {
            // var b
            this.$confirm(`${this.$t("tan.tan1")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_blsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },
        // 弹框
        tan2() {
            this.$confirm(`${this.$t("tan.tan2")}`, "提示", {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = this.fileList.ENVFROM;
                    console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_wlsender",
                                dnoremail: dnoremail,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },

        // 弹框
        tan3() {
            // var b

            this.$confirm(`${this.$t("tan.tan3")}`, "提示", {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;
                    // console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_ipbl",
                                ipaddr: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },
        // 弹框
        tan4() {
            // var b

            this.$confirm(`${this.$t("tan.tan4")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let ipaddr = this.fileList.PEER_IP;
                    // console.log(dnoremail);

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "save_ipwl",
                                ipaddr: ipaddr,

                                sid: sid,

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("tan.confirm1")}`,
                                });
                                this.getFileList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("tan.cancel1")}`,
                    });
                });
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/list_detail.less";
</style>
